import React from 'react';
import styles from './StatsBar.module.scss';

const stats = [
    { value: '100+', label: 'Students Tutored' },
    { value: '150+', label: 'Average Points Gain' },
    { value: '85%', label: 'Score Improvement Rate' },
    { value: '3+', label: 'Years of Expertise' },
];

const StatsBar = () => {
    return (
        <section className={styles.statsBar} aria-label="Statistics">
            {stats.map((stat, i) => (
                <React.Fragment key={i}>
                    <div className={styles.statItem}>
                        <span className={styles.statValue}>{stat.value}</span>
                        <span className={styles.statLabel}>{stat.label}</span>
                    </div>
                    {i < stats.length - 1 && (
                        <div className={styles.divider} aria-hidden="true" />
                    )}
                </React.Fragment>
            ))}
        </section>
    );
};

export default StatsBar;
